import { getFooterIconList } from '../../Footer/FooterIconList';
export default function FooterC1Share({ locale, theme = 'black' }: { locale: string; theme: 'white' | 'black' | 'gray' }) {
    const IconList = getFooterIconList(locale);
    return <IconList theme={theme} />;
}
